<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('invest.recharge') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/rechargeRecord')"
      >
        <van-icon
          name="bars"
          size="25"
        />
      </div>
    </div>
    <div
      v-if="eye==1"
      class="balance "
    >
      <p>
        {{ $t('sky.jifen') }}
      </p>
      <p>
        {{ parseInt(balance) }} 
      </p>
      <p>
        {{ $t('invest.availableBalance') }}
      </p>
    </div>
    <div
      v-if="eye==0"
      class="balance bglight"
    >
      <p>
        ******
      </p>
      <p>
        {{ $t('invest.availableBalance') }}
        <van-icon
          name="closed-eye"
          @click="eye=1"
        />
      </p>
    </div>
    <form class="form">
      <div class="recharge_wrap bgdeep">
        <p>{{ $t('invest.rechargeAmount') }}</p>
        <div class="flex_center">
          <input
            v-model.trim="data.money"
            type="number"
            min="1"
            step="1"
            class="inp"
            :placeholder="$t('invest.rechargeAmount')"
            @input="changeAmount"
          >
          <!-- <span>{{actualAmount}}</span> -->
          <span> {{ payment.mark }} </span>
          <span>（{{ actualAmount }}）</span>
        </div>
      </div>
      <!-- <div class="recharge_wrap" v-if="data.channel!=5">
				<p>{{$t('invest.sendAddress')}}</p>
				<div class="flex_center">
					<input v-model.trim="data.reason" type="text" class="reason"
						:placeholder="$t('invest.sendAddress')">
				</div>
			</div> -->
      <div class="recharge_fs bgdeep">
        <div class="tit">
          {{ $t('invest.paymentMethod') }}
        </div>
        <div
          v-for="(v, k) in config.payment"
          :key="k"
          class="item"
          @click="choose_type(k+1,v)"
        >
          <div
            class="check"
            :class="k+1 == data.choose? 'checked' : ''"
          />
          <div class="re_icon">
            <img :src="v.logo">
          </div>
          <div class="re_name">
            {{ v.name }}
          </div>
        </div>
      </div>
      <div
        class="basic_btn sbtn"
        @click="submit"
      >
        {{ $t('invest.next') }}
      </div>
    </form>
		
    <div
      v-if="data.channel!=5"
      class="tip bglight"
    >
      {{ $t('invest.tip') }}
    </div>
    <!-- <div style="margin: 20px;line-height: 20px;text-align: center;margin-top: 50px;">
			<img class="footimgs" src="../images/ban2/onekey__expedia.svg">
			<img class="footimgs" src="../images/ban2/onekey__hotels__english.svg">
			<img class="footimgs" src="../images/ban2/onekey__vrbo.svg">
		</div>
		<div class="footerdesc">
			<div class="version">
				Expedia 2025.46.1 (252432001)
			</div>
			<div class="copyright">
			 © Hak Cipta 2012-2025 Expedia Group Semua hak cipta dilindungi undang-undang.
			</div>
		</div> -->
  </div>
</template>

<script>
	import Vue from 'vue';
	import {
		CountDown,
		Checkbox,
		RadioGroup,
		Icon,
		Radio
	} from 'vant';
	import {
		jsBridge
	} from '../../utils/jsbridge-mini.js';
	import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";

	Vue.use(RadioGroup);
	Vue.use(Radio);
	Vue.use(CountDown).use(Checkbox).use(Icon);

	export default {
		name: "Invest",
		data() {
			return {
				time: 0,
				eye: 1,
				balance: 0.00,
				data: {
					choose: '',
					channel: '',
					money: '',
					id: '',
					reason:''
				},
				payment:[],
				config: {},
				actualAmount:'',
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
			var num = this.$router.history.current.params.code;
			if(num && num>0){
				this.data.money= num;
			}
		},
		methods: {
			start() {
				Fetch('/user/recharge', {
					...this.data
				}).then((r) => {
					this.balance = r.data.money;
					this.config = r.data;
					this.config.min_recharge = parseInt(this.config.min_recharge);
					this.choose_type(1,r.data.payment[0]);
				});
			},
			checkLimit() {
				
				const key = 'invest_button';
				const ttl = 60;
				let now = Date.parse(new Date()) / 1000;
				let val = localStorage.getItem(key);
				if (!val) {
					val = JSON.stringify({
						'ttl': now + ttl
					})
					localStorage.setItem(key, val)
					return true;
				} else {
					val = JSON.parse(val);
					if (val['ttl'] > now) {
						return false;
					} else {
						val = JSON.stringify({
							'ttl': now + ttl
						})
						localStorage.setItem(key, val)
						return true;
					}
				}
			},
			choose_type(k, payment) {
				this.data.choose = k;
				this.data.channel = payment.type;
				this.data.id = payment.id;
				this.payment = payment;
				this.changeAmount();
			},
			submit() {
				if (!this.data.money || this.data.money < this.config.min_recharge) {
					this.$toast(this.$t('invest.rechargeAmountLow') +" "+ this.utils_moneyMark() + this.config
						.min_recharge + this.$t('invest.rechargeAmountLow1'));
					return false;
				}
				if (!this.data.channel) {
					this.$toast(this.$t('invest.paymentMethodEmpty'));
					return false;
				}
				// if (!this.data.reason&&this.data.channel!=5) {
				// 	this.$toast(this.$t('invest.sendAddress'));
				// 	return false;
				// }
				// if (!this.checkLimit()) {
				// 	this.$toast(this.$t('invest.overtop'));
				// 	return false;
				// }

				if (this.data.channel == 4) {
					this.$router.replace({
						path: '/invest/bank',
						query: {
							money: this.data.money,
							id: this.data.id
						}
					})
					return;
				} else if (this.data.channel == 2) {
					this.$router.replace({
						path: '/invest/alipay',
						query: {
							money: this.data.money,
							type: this.data.channel,
							id: this.data.id
						}
					})
					return;
				} else if (this.data.channel == 3) {
					this.$router.replace({
						path: '/invest/wx',
						query: {
							money: this.data.money,
							type: this.data.channel,
							id: this.data.id
						}
					})
					return;
				} else if (this.data.channel == 1) {
					this.$router.push("/kefu");
					// this.$router.replace({
					// 	path: '/invest/usdt',
					// 	query: {
					// 		money: this.data.money,
					// 		id: this.data.id,
					// 		reason:this.data.reason
					// 	}
					// }).then((r) => {
						  
					// 	 //  if(r.data.payment.payurl!=''){
					// 		// // window.open(r.data.payment.payurl,'_blank');
					// 		// window.location.href = r.data.payment.payurl;
					// 	 //  }
					// });
					return;
				} else {
					//第三方支付
					  Fetch('/user/recharge_type', {
						money: this.data.money,
						id:this.data.id
					  }).then((r) => {
						  this.$router.push("/kefu");
						  if(r.data.payment.payurl!=''){
							// window.open(r.data.payment.payurl,'_blank');
							// window.location.href = r.data.payment.payurl;
						  }
					  });
				}
				// Fetch('/user/invest/apply', {
				//     ...this.data
				// }).then(() => {
				//     this.$router.replace('/login');
				// });
			},
			changeAmount() {
				var num = 0;
				if(this.payment.type){
					if (this.payment.type == 1) {
						if (this.payment.rate > 10000) {
							num = 8;
						} else if (this.payment.rate > 1000) {
							num = 6;
						} else if (this.payment.rate > 10) {
							num = 4;
						}
						this.actualAmount = " ≈ " + (this.data.money / this.payment.rate).toFixed(num) + ' '+ this.utils_moneyMark();
					} else {
						this.actualAmount = " ≈ " + this.payment.mark + " " + (this.data.money / this.payment.rate).toFixed(num);
					}
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
	}

	.balance {
		border-radius: 6px;
		padding: 20px 0px;
		text-align: center;
		margin: 10px;
		border: 1px solid #CCC;
		p:nth-child(1) {
			color: #000;
			font-size: 14px;
			margin-bottom: 15px;
		}
		p:nth-child(2) {
			color: #000;
			font-size: 20px;
			font-weight: bold;
			margin-bottom: 15px;
		}
		p:nth-child(3) {
			color: #999;
			font-size: 14px;
			font-weight: bold;
		}
	}

	.recharge_fs {
		margin-top: 10px;
		border-radius: 6px;
		padding: 0 16px;
		border: 1px solid #CCC;
		background-color: #FFF;
	}

	.recharge_box {
		width: 100%;
		height: 48px;
		background: rgba(255, 255, 255, 1);
		border-radius: 6px;
		margin-top: 12px;
		padding: 16px 11px;

		input {
			height: 18px;
			width: 100%;
			line-height: 18px;
			font-size: 14px;
		}
	}

	.form {
		margin: 10px;

		.recharge_wrap {
			width: 100%;
			border-radius: 6px;
			padding: 16px;
			margin-top: 10px;
			background-color: #FFF;
			border: 1px solid #CCC;
			.flex_center {
			  justify-content: left;
			}
			.reason{
				width: 100%;
			}
			input {
				height: 18px;
				width: 40%;
				line-height: 18px;
				font-size: 14px;
			}
			div {
				span:nth-child(2){
					font-size: 18px;
					margin-right: 10px;
					margin-left: 10px;
					font-weight: bold;
				}
				// span:nth-child(3){
				// 	font-size: 14px;
				// 	width: 40%;
				// 	color: #999;
				// 	text-align: right;
				// }
			}

			p:nth-child(1) {
				font-size: 16px;
				font-weight: bold;
				margin-bottom: 20px;
			}

			p:nth-child(3) {
				color: #999;
				margin-top: 20px;
			}

		}

		.tit {
			height: 54px;
			border-bottom: 1px solid #ECECEC;
			font-size: 16px;
			font-weight: bold;
			line-height: 54px;
		}

		.item {
			height: 57px;
			border-bottom: 1px solid #ECECEC;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			&:last-child {
				border-bottom: none;
			}

			.check {
				width: 16px;
				height: 16px;
				margin-left: 4px;
				background: url(../images/user/c2.png) no-repeat center center;
				background-size: 100% 100%;

				&.checked {
					background: url(../images/user/c1.png) no-repeat center center;
					background-size: 100% 100%;
				}
			}

			.re_icon {
				width: 35px;
				height: 35px;
				margin-left: 11px;

				img {
					width: 35px;
					height: 35px;
				}
			}

			.re_name {
				font-size: 16px;
				line-height: 22px;
				margin-left: 4px;
			}

			.wx {
				background: url(../images/user/recharge3.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.alipay {
				background: url(../images/user/recharge2.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.usdt {
				background: url(../images/user/recharge1.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.alipay_app {
				background: url(../images/user/recharge2.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.bank {
				background: url(../images/user/recharge4.png) no-repeat center center;
				background-size: 100% 100%;
			}
		}
	}
	.tip{
		display: block;
		margin: 8px;
		padding: 16px;
		border-radius: 16px;
		line-height: 24px;
		font-size: 12px;
	}
	.sbtn {
		margin: 10vw auto 0 auto;
	}

	/* Ivory, champagne-gold and rose-wine recharge page theme. */
	.recharge_wrap { min-height: 100vh; padding-bottom: calc(88px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); color: #533126; }.red_top_bg { height: 54px; background: rgba(255, 252, 245, .97); border-bottom: 1px solid rgba(190, 139, 52, .45); }.red_top_bg .big_tit, .red_top_bg .back_left, .red_top_bg .top_right /deep/ .van-icon { color: #8f251d !important; }
	.balance { margin: 14px; padding: 17px 0; border-color: rgba(190, 139, 52, .55); border-radius: 16px; background: linear-gradient(135deg, #fffdf8, #f7deb0 105%); box-shadow: 0 14px 30px rgba(126, 84, 29, .12); }.balance p:nth-child(1), .balance p:nth-child(3) { color: #815c45; }.balance p:nth-child(2) { color: #a6233d; font-size: 20px; }
	.form { margin: 0 14px; }.form .recharge_wrap, .recharge_fs { min-height: 0; margin-top: 13px; padding: 17px 16px; border: 1px solid rgba(190, 139, 52, .5); border-radius: 14px; background: #fffdf8; box-shadow: 0 10px 22px rgba(126, 84, 29, .1); }.form .recharge_wrap p:nth-child(1), .form .tit { margin-bottom: 12px; border-bottom-color: rgba(190, 139, 52, .2); color: #533126; font-size: 14px; }.form .recharge_wrap .flex_center { min-height: 44px; border: 1px solid rgba(190, 139, 52, .32); border-radius: 9px; background: #fff8e9; padding: 0 10px; }.form .recharge_wrap input { width: 45%; min-width: 0; height: 40px; color: #533126; }.form .recharge_wrap input::placeholder { color: #9c8068; }.form .recharge_wrap div span:nth-child(2) { color: #a6233d; }.form .recharge_wrap div span:nth-child(3) { color: #815c45; font-size: 12px; }
	.recharge_fs { padding: 0 16px; }.form .tit { height: 51px; margin: 0; line-height: 51px; }.form .item { height: 58px; border-bottom-color: rgba(190, 139, 52, .18); color: #533126; }.form .item .re_icon img { border-radius: 8px; filter: none; }.form .item .re_name { color: #533126; }.form .item .check { filter: none; }
	.sbtn { width: 100%; height: 50px; margin: 24px auto 0; border: 1px solid #b9802e; border-radius: 12px; background: linear-gradient(105deg, #a6233d, #ca5a5b) !important; color: #fff9ea !important; line-height: 48px; box-shadow: 0 9px 20px rgba(151, 17, 56, .18); }.tip { margin: 12px 14px 0; border: 1px solid rgba(190, 139, 52, .38); border-radius: 13px; background: #fffdf8; color: #815c45; }
</style>
